import React from 'react';

import { Text } from '@reckon-web/text';
import { ArrowRightIcon } from '@reckon-web/icon';
import { Flex } from '@reckon-web/flex';

import { getPropertyNew, getPropertyOld, getTargetType } from '../helper';
import { GetActivityItem } from '../../../data/useGetActivities';

interface IActivityCategoryFieldUpdated {
  activity: GetActivityItem;
}

// ActivityCategory FieldUpdated = 2
export const ActivityCategoryFieldUpdated = ({
  activity,
}: IActivityCategoryFieldUpdated) => {
  const targetType = !activity.targetType
    ? ''
    : getTargetType(activity.targetType);

  const propertyNameOverrides = new Map([
    // terminology wise, client is now known as debtor
    ['job.client', 'debtor'],
    // terminology wise, entity is now known as client
    ['job.entities', 'clients'],
    ['task.entity', 'client'],
  ]);

  // we'll get something like 'DueDate'
  // we need 'due date' coming out
  // this is a dumb implementation and doesn't take into account abbreviations like ETA. Don't think there are any of them
  const propertyNameDisplay = () => {
    if (!activity.propertyName) {
      return '';
    }

    const overrideKey = targetType + '.' + activity.propertyName.toLowerCase();
    if (propertyNameOverrides.has(overrideKey)) {
      return propertyNameOverrides.get(overrideKey);
    }

    return activity.propertyName
      .replace(/([A-Z])/g, ' $1') // insert a space before each uppercase
      .toLowerCase(); // then lower the whole lot
  };

  const propertyOld = activity.propertyOld;
  const propertyNew = activity.propertyNew;

  // mDash is displayed to indicate empty values
  const mDash = (
    <Text size="small" weight="medium">
      &mdash;
    </Text>
  );

  return (
    <Flex direction="column" gap="small">
      <Text size="small">
        Edited {targetType} {propertyNameDisplay()}
      </Text>
      <Flex alignItems="center" gap="xxsmall">
        {propertyOld && !propertyNew ? (
          <Flex alignItems="center" gap="xsmall">
            <Text size="small">{getPropertyOld(activity)} </Text>
            <Flex flexShrink={0}>
              <ArrowRightIcon size="small" color="dim" />
            </Flex>
            {mDash}
          </Flex>
        ) : !propertyOld && propertyNew ? (
          <Flex alignItems="center" gap="xsmall">
            {mDash}
            <Flex flexShrink={0}>
              <ArrowRightIcon size="small" color="dim" />
            </Flex>
            <Text size="small">{getPropertyNew(activity)}</Text>
          </Flex>
        ) : (
          <Flex alignItems="center" gap="xsmall">
            {propertyOld ? getPropertyOld(activity) : mDash}
            <Flex flexShrink={0}>
              <ArrowRightIcon size="small" color="dim" />
            </Flex>
            {propertyNew ? getPropertyNew(activity) : mDash}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
